import { DocumentMode } from '@root/@types/types';

import type { TransitionConfigMap } from '../types';

export const ARCHIVED_TRANSITIONS: TransitionConfigMap = {
  DRAFT: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Return to Draft state?',
      content: 'Setting this contract back to Draft will make it editable again.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Return to Draft state?',
      content: 'Setting this template back to Draft will make it editable again.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Return to Draft state?',
      content: 'Setting this endorsement back to Draft will make it editable again.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
  },
};
